<template>
  <div>
    <b-modal v-model="showAccessModal" title="Access Restricted" :ok-only="true" @ok="redirectDashboard">
      Sorry, but you do not have access to Post at this time.
    </b-modal>
  </div>
</template>
<script>

export default {
  data() {
    return {
      credentials: {
        email: '',
        password: '',
        remember_me: false,
      },
      showAccessModal:false,
      origin:window.location.origin,
      loadingLogin: false,
      pw:this.$route.params.pw,
      action:this.$route.params.action,
      review_id:this.$route.params.id ?? null,
      token:this.$route.params.token ?? null,
      type:this.$route.params.type ?? null,
      add:this.$route.params.add ?? null
    }
  },
  computed:{
    user() {
      return this.$store.getters['auth/user']
    },
  },
  mounted() {
    // Always authenticate with the magic-link token from the URL. Skipping when a
    // session already exists (e.g. agency owner opens a customer's Setup Now link)
    // would redirect the wrong user to Google connect and show a 404.
    this.handleLogin();
  },
  methods: {
    handleLogin() {
      this.loadingLogin = true
      this.$store
        .dispatch('auth/autologin', {token:this.pw})
        .then(() => {
          this.$store
              .dispatch('auth/getProfile')
              .then((user) => {
                this.processRedirects();
              })
              .catch(() => {
                this.loadingLogin = false
              })
        })
        .catch(() => {
          this.loadingLogin = false
        })
    },
    redirectDashboard(){
      this.$router.push({ name: 'new-business.dashboard' });
    },
    processRedirects(){
      if(window.location.href.includes('business/social-posts') && !this.user.business?.is_social_fusion){
        this.showAccessModal = true;
        return
      }
      switch(this.action){
        case 'setup':
          this.$router.push({name:'connect.google'});
          break;
        case 'approve':
          this.$router.push({name:'business.process-review',query:{action:'approve'}, params:{id:this.review_id}});
          break;
        case 'rewrite':
          this.$router.push({name:'business.process-review',query:{action:'rewrite'}, params:{id:this.review_id}});
          break;
        case 'reject':
          this.$router.push({name:'business.process-review',query:{action:'reject'}, params:{id:this.review_id}});
          break;
        default:
          this.$router.push({
            name: 'new-business.social-posts',
            params: { token: this.token, type: this.type, add: this.add },
          });
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.auth-container {
  width: 100%;
  max-width: 615px;
  margin: 0 auto;
  margin-top: 15vh;
  .custom-control-label {
    &:before,
    &:after {
      width: 20px;
      height: 20px;
      top: 0px;
    }
  }
  .input-group-text {
    padding: 5px 10px;
  }
  .login-header{
    background: #1e3260;
  }
}
</style>
